/**
 * The game menu's words. Its items are the row's and the brief's; Change character's question and Log out's are the
 * design's (P1.9-T62, P2.3-T4), each naming the stay in the world, whose 10 seconds are the rules' `logout_stay`
 * (a test holds the two together). The items that open another window read that window's own word and
 * are not here: Emotes is the action's name in Controls, Change look is the look screen's, Feedback is the form's
 * and Log out everywhere is that dialog's confirm, so the two can never differ.
 *
 * `leave` holds a chosen leave's words (P2.3-T4, ADR-084's amendment of 2026-10-13). The design's: what each of
 * Change character and Log out says at its right while a fight locks it, with the whole seconds left (`wait`), and
 * the sentence under the menu (`locked`). Drafts for the author: both when no whole second is left to name
 * (`waitSoon`, `lockedSoon`); and the dialog a page shows while its character stays in the world after the leave: its
 * title, the name of its bar, its sentence with the whole seconds left (`staying`) and when the stay has run out
 * (`left`).
 *
 * `render`: what a pending Render resolution choice costs and why the window offers no more (ADR-093). `{to}` and
 * `{from}` are the tile counts or the HUD scales as the page prints them, and `{width}` and `{height}` are a view in tiles, and `{divisor}` is `full`, `half` or `a third`.
 */
export const MENU = {
  items: {
    resume: "Resume",
    settings: "Settings",
    inventory: "Inventory",
    character: "Character",
    change: "Change character",
    logout: "Log out",
  },
  changeQuestion: {
    title: "Change character?",
    body: "You stay in the world for 10 s, then return to character select. You stay logged in.",
    confirm: "Change character",
  },
  logoutQuestion: {
    title: "Log out?",
    body: "You stay in the world for 10 s after you log out. To log out other devices, use Settings, Account.",
    confirm: "Log out",
  },
  leave: {
    wait: "In combat: wait {seconds} s",
    waitSoon: "In combat",
    locked: "You are in combat. Change character and Log out open in {seconds} s.",
    lockedSoon: "You are in combat. Change character and Log out open soon.",
    stayTitle: "Leaving",
    stayBar: "Time until you leave",
    staying: "Your character stays in the world for {seconds} s.",
    left: "Your character has left the world.",
  },
  render: {
    lessWorld: "Shows less of the world: {to} tiles instead of {from}.",
    smallerHud: "Makes the HUD smaller: scale {to} instead of {from}.",
    tooFewPixels: "This screen has too few pixels to draw at {divisor}.",
    tilesBy: "{width} by {height}",
    full: "full",
    half: "half",
    third: "a third",
  },
} as const;
